import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { Input, Label, FormGroup, FormFeedback, Modal, ModalBody, ModalHeader, Button, Row, Col } from 'reactstrap'
import { setCampaignData } from 'redux/actions/marketing'
import { SelectWithLabel, TextNumberFormat } from 'components/Form'
const _ = require('lodash')

const FacebookAdditionalFields = () => {
  const dispatch = useDispatch(null)
  const campaign = useSelector((state) => state.marketing.campaign)

  const [showModal, setShowModal] = useState(false)
  const [errors, setErrors] = useState([])

  const [facebookCampaign, setFacebookCampaign] = useState({
    bid_amount: 0,
    budget_type: '',
    budget_amount: 0,
  })

  const toggleModal = () => setShowModal((show) => !show)

  React.useEffect(()=> {
    setFacebookCampaign(campaign.facebookCampaign)
  }, [campaign.facebookCampaign])

  const budgetOptions = [
    { label: I18n.t('campaign_facebook_daily_budget'), value: 'daily_budget' },
    { label: I18n.t('dashboard_total-budget'), value: 'lifetime_budget' },
  ]

  const handleInputChange = ({ target }) => {
    const { name, value } = target
    const facebookObj = { ...facebookCampaign, [name]: value }
    setErrors(_.remove(errors, name))
    setFacebookCampaign(facebookObj)
  }

  const handleBudgetTypeChange = ({ value }) => {
    const facebookObj = { ...facebookCampaign, budget_type: value }
    setErrors(_.remove(errors, 'budget_type'))
    setFacebookCampaign(facebookObj)
  }

  const validateFields = () => {
    if (!facebookCampaign.bid_amount || facebookCampaign.bid_amount <= 0) {
      setErrors((errors) => errors.concat('bid_amount'))
      return false
    }
    if (!facebookCampaign.budget_type) {
      setErrors((errors) => errors.concat('budget_type'))
      return false
    }
    if (!facebookCampaign.budget_amount || facebookCampaign.budget_amount <= 0) {
      setErrors((errors) => errors.concat('budget_amount'))
      return false
    }
    return true
  }
  const submitCampaignData = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (validateFields()) {
      dispatch(setCampaignData({ ...campaign, facebookCampaign }))
      return toggleModal()
    }
  }
  return (
    <div>
      <Button className='font-weight-normal' color='default' onClick={toggleModal}>
        <label style={{ fontSize: '12px', fontWeight: 'bold' }}>{I18n.t('campaign_facebook_necessary_info')}</label>
      </Button>
      <Modal isOpen={showModal} toggle={toggleModal}>
        <ModalHeader> {I18n.t('campaign_facebook_necessary_info_fields')}</ModalHeader>
        <ModalBody>
          <FormGroup inline>
            <Row>
              <Col md={6}>
                <Label for='bid_info' className='new-label'>
                  {' '}
                </Label>
                <div className='hint'>
                  <p className='hint-text'>{I18n.t('campaign_facebook_bid_text')}</p>
                </div>
              </Col>
              <Col md={6}>
                <Label for='bid_amount' className='new-label'>
                  {I18n.t('campaign_facebook_bid_amount')}
                </Label>
                <div style={{ position: 'relative' }}>
                  <TextNumberFormat
                    defaultValue={facebookCampaign.bid_amount}
                    name='bid_amount'
                    customInput={Input}
                    onChange={value => handleInputChange({ target: { name: 'bid_amount', value: isNaN(value) ? 0 : value } })}
                    className={'new-input'}
                    required
                    invalid={errors.includes('bid_amount')}
                  />
                  <FormFeedback>{I18n.t('dashboard_required-field')}</FormFeedback>
                  <span className='input-group-text wrapper-icon-euro'>
                    <i className='fa fa-eur'></i>
                  </span>
                </div>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup inline>
            <Row>
              <Col md={6}>
                <Label for='budget_type' className='new-label'>
                  {I18n.t('campaign_facebook_budget_type')}
                </Label>
                <SelectWithLabel placeholder={I18n.t('dashboard_choose-type')} options={budgetOptions} onChange={handleBudgetTypeChange} value={budgetOptions.find(el => el.value === facebookCampaign.budget_type)} />
                <Input type='text' hidden={true} invalid={errors.includes('budget_type')} />
                <FormFeedback>{I18n.t('dashboard_required-field')}</FormFeedback>
              </Col>
              <Col md={6}>
                <Label for='budget_amount' className='new-label'>
                  {I18n.t('campaign_facebook_budget_amount')}
                </Label>
                <div style={{ position: 'relative' }}>
                  <TextNumberFormat
                    defaultValue={facebookCampaign.budget_amount}
                    name='budget_amount'
                    customInput={Input}
                    onChange={value => handleInputChange({ target: { name: 'budget_amount', value: isNaN(value) ? 0 : value } })}
                    className={'new-input'}
                    required
                    invalid={errors.includes('budget_amount')}
                  />
                  <FormFeedback>{I18n.t('dashboard_required-field')}</FormFeedback>
                  <span className='input-group-text wrapper-icon-euro'>
                    <i className='fa fa-eur'></i>
                  </span>
                </div>
              </Col>
            </Row>
          </FormGroup>
          <Button onClick={submitCampaignData}>{I18n.t('dashboard_send')}</Button>
        </ModalBody>
      </Modal>
    </div>
  )
}
export default FacebookAdditionalFields
